import { focusableCSS } from '@ardoq/style-helpers';
import { JSX } from 'react';
import styled from 'styled-components';

export type UnstyledLinkProps = {
  href: string;
  onClick?: VoidFunction;
  onTrack?: VoidFunction;
  target?: '_self' | '_blank';
};

const FocusableLink = styled.a`
  ${focusableCSS};
`;

/**
 * Unstyled anchor/link component for soft navigation.
 *
 * @param props Props, usually returned by {@link toLinkProps} or {@link toLinkPropsReturningActions}.
 * @returns React node that renders a link.
 */
export const UnstyledLink = ({
  onTrack,
  ...props
}: JSX.IntrinsicElements['a'] & Pick<UnstyledLinkProps, 'onTrack'>) => (
  <FocusableLink
    {...props}
    target={props.target ?? (props.onClick ? '_self' : '_blank')}
    onClick={event => {
      onTrack?.();
      if (!isRegularClick(event) || !props.onClick) {
        return;
      }
      event.preventDefault();
      props.onClick?.(event);
    }}
    onAuxClick={event => {
      if (isMiddleClick(event)) {
        onTrack?.();
      }
    }}
  />
);

const isRegularClick = (event: React.MouseEvent): boolean =>
  event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey;

const isMiddleClick = (event: React.MouseEvent): boolean => event.button === 1;
